import Button from "components/Buttons/ThemeButton";
import styled, { CSSProperties } from "styled-components";

export const Container = styled("div")<{ scale: number }>`
	width: 19em;
	height: 30em;
	padding: 0px;
	position: relative;
	display: flex;
	justify-content: center;
	overflow: hidden;
	border-radius: 22px;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
	background-color: #c5c5c5;
	font-size: 1.25rem;

	@media (orientation: landscape) {
		width: 50em;
		height: 19em;
	}
`;

export const Background = styled.div<{ imageUrl?: string }>`
	content: url(${(props) => props.imageUrl});
	width: 100%;
	height: 100%;
`;

export const Text = styled.div`
	-webkit-text-stroke-width: 0.21em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	font-weight: 400;
	font-family: Baloo;
`;

export const Subtitle = styled(Text)`
	position: absolute;
	text-align: center;
	max-width: 85%;
	top: 17.5%;
	font-size: 1.2em;
	line-height: 1.05em;
	letter-spacing: 0.04em;

	@media (orientation: landscape) {
		top: 29%;
	}
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 100%;
	top: 44%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		top: 37%;
	}
`;

export const EarnBox = styled.div<{ $backgroundImage: string }>`
	background: url(${(props) => props.$backgroundImage});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	position: relative;
	border-radius: 18px;
	width: 13.4em;
	height: 6.7em;
	display: flex;
	justify-content: right;
	align-items: center;
`;

export const Circle = styled.div`
	position: absolute;
	left: 2%;
	top: 48%;
	transform: translateY(-50%);
	border-radius: 50%;
	padding: 0.5em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: auto;
	z-index: 999;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	width: 6em;
	height: 6.4em;
`;

export const RewardContainer = styled.div`
	position: absolute;
	bottom: 1em;
	justify-content: center;
	align-items: center;
	display: flex;
	height: 75%;
`;

export const RewardItem = styled.div<{ width?: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
`;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;
	width: 100%;
	height: 3.9em;
`;

export const EarnedText = styled(Text)`
	position: absolute;
	top: 20%;
	left: 49%;
	font-size: 0.72em;
	line-height: 1.7em;
`;

export const EarnedNumber = styled.div`
	color: #fbbd05;
	text-align: center;
	paint-order: stroke fill;
	//text-shadow: 1.08px 1.08px 0 #000;
	-webkit-text-stroke-width: 0.1em;
	-webkit-text-stroke-color: #000;
	font-family: Baloo;
	font-size: 3.17em;
	line-height: 1em;
	font-style: normal;
	font-weight: 400;
	width: 60%;
	height: 62%;
	display: flex;
	justify-content: center;
	align-items: end;
`;

export const InboxMessage = styled(Text)`
	position: absolute;
	text-align: center;
	max-width: 75%;
	bottom: 2%;
	font-size: 0.92em;
	line-height: 1.2em;
	letter-spacing: 0.04em;
`;

export const ButtonsContainer = styled.div`
	position: absolute;
	bottom: 11%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 90%;

	@media (orientation: landscape) {
		width: 66%;
		gap: 0.5em;
		flex-direction: row;
	}
`;

export const CustomButton = styled(Button)`
	width: 100%;
	margin-top: 0.5em;
	height: 2.8em;
	font-size: 1em;

	@media (orientation: landscape) {
		width: 60%;
		gap: 0.5em;
		flex-direction: row;
	}
`;

export const CountdownStyles: CSSProperties = {
	fontSize: "0.8em",
	margin: "0em 0.36em",
	background: "rgba(208, 110, 223, 0.90)",
	top: "4.5%"
};

export const CountdownStylesPortrait: CSSProperties = {
	fontSize: "0.73em",
	margin: "0em 0.36em",
	background: "rgba(208, 110, 223, 0.90)",
	top: "2%",
	left: "2%",
	padding: "0.25em 0.4em"
};

export const CountdownIconStyles: CSSProperties = {
	width: "1.5em",
	height: "1.5em",
	display: "none"
};

export const CountdownLabelStyles: CSSProperties = {
	//marginLeft: "0em",
	textShadow: "0 1.06px 0 rgba(0, 0, 0, 0.25)"
};
